/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ principal: NonNullable<unknown> }} Onboarding_V1_Projection_Starting_WithInputs */

const en_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starting with ${i?.principal}.`)
};

const de_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ausgehend von ${i?.principal}.`)
};

const pt_br2_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começando com ${i?.principal}.`)
};

const tr_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.principal} ile başlayarak.`)
};

const zh_cn2_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从 ${i?.principal} 开始。`)
};

const zh_hk2_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 ${i?.principal} 開始。`)
};

const ko_kr2_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.principal}에서 시작합니다.`)
};

const ru_ru2_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начальная сумма — ${i?.principal}.`)
};

const es_419_onboarding_v1_projection_starting_with = /** @type {(inputs: Onboarding_V1_Projection_Starting_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comenzando con ${i?.principal}.`)
};

/**
* | output |
* | --- |
* | "Starting with {principal}." |
*
* @param {Onboarding_V1_Projection_Starting_WithInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_starting_with = /** @type {((inputs: Onboarding_V1_Projection_Starting_WithInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_Starting_WithInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_starting_with(inputs)
	if (locale === "de") return de_onboarding_v1_projection_starting_with(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_starting_with(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_starting_with(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_starting_with(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_starting_with(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_starting_with(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_starting_with(inputs)
	return es_419_onboarding_v1_projection_starting_with(inputs)
});